// extracted by mini-css-extract-plugin
export default {"Shelf":"hoLZqezZ","ShelfContainer":"aRVtYipt","Spacer":"ax1LBm0p","Modal":"a3xoLZ6S","Drawer":"UwgGNupn"};